import React from 'react';
import type { Icon } from '@tabler/icons-react';
import EmptyState from '@/components/ui/Empty.State';

type Props = { icon: Icon; title: string; body: string };

const SpotlightEmpty: React.FC<Props> = ({ icon, title, body }) => (
    <EmptyState compact icon={icon} title={title} body={body} />
);

export default SpotlightEmpty;
